import cx from "clsx";
import { icon, dark, light } from "./ColorSchemeControl.module.css";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { ActionIcon, Tooltip, useMantineColorScheme } from "@mantine/core";
import { useIntl } from "react-intl";
import { setInitialTheme } from "@project/common";

export function ColorSchemeControl() {
  const intl = useIntl();
  const { setColorScheme, colorScheme } = useMantineColorScheme();

  const ariaLabel = intl.formatMessage({
    defaultMessage: "Toggle color scheme",
    id: "label.toggleColorScheme",
  });

  const tooltipDark = intl.formatMessage({
    defaultMessage: "Dark mode",
    id: "label.themeDark",
  });
  const tooltipLight = intl.formatMessage({
    defaultMessage: "Light mode",
    id: "label.themeLight",
  });

  return (
    <Tooltip label={colorScheme === "dark" ? tooltipLight : tooltipDark}>
      <ActionIcon
        size={28}
        variant="subtle"
        color={colorScheme === "dark" ? "light" : "dark"}
        onClick={() => {
          const nextTheme = colorScheme === "dark" ? "light" : "dark";
          setInitialTheme(nextTheme);
          setColorScheme(nextTheme);
        }}
        aria-label={ariaLabel}
      >
        <IconSun className={cx(icon, light)} />
        <IconMoon className={cx(icon, dark)} />
      </ActionIcon>
    </Tooltip>
  );
}
